import React, { useEffect, useState, useMemo, useRef } from "react";
import "./OrderPlanSearchResultCard.scss";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../api/API-Url";
import ThemeBtn from "../ThemeBtn/ThemeBtn";
import dayjs from 'dayjs';



function OrderPlanSearchResultCard(props) {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);
    const fallbackImage = "https://funtlers.com/static/media/booking-confirmation-img.8df3502e7365d6433146.png"; // Fallback image



    let activity;
    //the rerouting from this component will be different if it is coming from customer side.
    if (props.source === "customer") {
        activity = props.Data;
        activity.userType = "customer";
    } else activity = props.activity;
            
    let res = activity.name.replace(/ /g, '-');
    res = res.replace(/\//g, '-');
    res = res.replace(/\?/g, '');


    const navigate = useNavigate();

    function DateFormat(date) {
        // Parse the input date into a JavaScript Date object
        const parsedDate = new Date(date);

        // Use Intl.DateTimeFormat to format the date in Norwegian
        let formattedDate = new Intl.DateTimeFormat('no-NO', {
            day: '2-digit',
            month: 'long',
            year: 'numeric',
        }).format(parsedDate);

        // Split the formatted date to capitalize only the first letter of the month
        const parts = formattedDate.split(' ');
        const month = parts[1].charAt(0).toUpperCase() + parts[1].slice(1); // Capitalize the first letter of the month
        parts[1] = month; // Replace the month part with the capitalized version

        // Rejoin the parts and return the formatted date
        return parts.join(' ');
    }


    const toActivityDetails = () => {
        if (props.source === "customer" || props.source === "partner") {
            localStorage.setItem('aktiviteter', activity.id);
            return navigate("/aktivitet/" + res + "?id=" + activity.id + "&type=B2B");
        }
        if (window.location.pathname === '/partner-aktiviteter')
            localStorage.setItem('partner-aktiviteter', props.partnerId);
        if (window.location.pathname === '/aktivitet-side')
            localStorage.setItem('aktivitet-side', activity.id);
        navigate("/redigere-aktivitet", { state: activity });
    };

    return (
        <>

            {props.isType && props.isType == "recommend-2" && (
                <>
                    <div
                        draggable
                        onDragStart={props.handleDrag}
                        className={`col-lg-3 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr2     ${(localStorage.getItem('aktivitet-side') === activity.id ||
                            localStorage.getItem('aktiviteter') === activity.id) &&
                            (window.location.pathname === '/aktivitet-side' ||
                                window.location.pathname === '/aktiviteter')
                            ? "scrollToActivity"
                            : ""
                            }`}
                    >
                        {/*<button id="x" onClick={props.handleDeleteActivity}>*/}
                        {/*    <i class="ri-close-line"></i>*/}
                        {/*</button>*/}


                        <div className={`outer-elemt2 ${!props.isVelgDisable && !activity.isVelgClick ? 'disabled-container' : ''} ${activity.isVelgClick ? 'liked-section' : ''}`}>

                            {/*<button id="x" onClick={props.handleDeleteActivity}>*/}
                            {/*    < i class="ri-thumb-up-line"></i>*/}
                            {/*</button>*/}

                            <h5 class="header-circle hoverid761-header top-datesec"><b>{dayjs(activity.addDate).locale('nb').format('DD MMMM')}</b></h5>

                            <div>
                                <div className="position-relative img_otr">
                                    <div className="card-menu">
                                        {activity.isVelgClick && (
                                            <>
                                                <div
                                                    className="m9 edit_icon_otr icon_otr" onClick={props.handleActivityEditClick}>
                                                    < i class="ri-pencil-line  edit_icon"></i>
                                                </div>
                                            </>)}
                                        <div
                                            className="m9 edit_icon_otr icon_otr"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                if (props.source === "customer" || props.source === "partner") {
                                                    toActivityDetails();
                                                    localStorage.setItem('aktiviteter', activity.id);
                                                }
                                            }}
                                        >
                                            <i className="ri-search-line edit_icon"></i>
                                        </div>
                                    </div>
                                    <Link
                                        className=""
                                        to={
                                            props.source === "customer" || props.source === "partner"
                                                ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                                : "#"
                                        }
                                    >
                                        <img 
                                            className="card_imgS"
                                            src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                            alt="img"
                                            loading="eager"
                                            style={{
                                                opacity: imageLoaded ? 1 : 0.3,  // Starts with low opacity
                                                transition: "opacity 0.5s ease-in-out", // Smooth fade-in effect
                                            }}
                                            onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                            onError={() => setImageError(true)} // If image fails, show fallback

                                            />
                                    </Link>
                                    {activity.discountPercent > 0 && activity.discountPercent < 100 && (
                                        <div>
                                            {/*    <p className="rabat_card_info shadow">-{activity.discountPercent}%</p>*/}
                                        </div>
                                    )}
                                </div>
                                <div className="content">
                                    <Link
                                        className="heading-lb card_heading"
                                        to={
                                            props.source === "customer" || props.source === "partner"
                                                ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                                : "#"
                                        }
                                    >
                                        {props.CardHeading}
                                    </Link>
                                    <div className="d-flex flex-row justify-content-between p-3 mid">
                                        <div className="d-flex flex-column align-left">
                                            <small className="text-muted "><b>PRIS:</b></small>
                                            <div className="d-flex flex-row">

                                                <div className="d-flex flex-column ml-1 ">
                                                    <small className="ghj f-12">{props.CardDesc}</small>
                                                </div>
                                            </div>

                                            <small className="text-muted "><b>ANTALL:</b></small>
                                            <div className="d-flex flex-row">

                                                <div className="d-flex flex-column ml-1 ">
                                                    <small className="ghj f-12">{(activity.minPerson + activity.totPersons)}</small>
                                                </div>
                                            </div>

                                            <small className="text-muted"><b>TOTALSUM:</b></small>
                                            <div className="d-flex flex-row">

                                                <div className="d-flex flex-column ml-1 mb-1">
                                                    <small className="ghj f-12">{(activity?.price || 0) * (activity?.minPerson + activity.totPersons)} NOK</small>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="d-flex flex-column">
                                            <small className="text-muted"><b>KATEGORI</b></small>
                                            <div className="d-flex flex-column">
                                                <i className={`sub-category-box2 ${props.CategoryDetails?.icon}`}></i>
                                                <div className="d-flex flex-column ml-1">
                                                    <small className="ghj fnt12">{props.CategoryDetails?.value}</small>
                                                </div>
                                            </div>

                                          
                                        </div>
                                    </div>
                                </div>
                                <div className="dflex w-100" >
                                    {!activity.isVelgClick &&
                                        <ThemeBtn
                                            BtnClass={` like-dislike like ${activity.isVelgClick ? 'disabled' : ''}   ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''}`}
                                            BtnText={
                                                <>
                                                    <i className="ri-thumb-up-fill"></i>
                                                </>
                                            }
                                            onClick={props.clickFire}
                                        />
                                    }

                                    {activity.isVelgClick &&
                                        <div
                                            className={` like-dislike-selected    `}

                                        >
                                            <i className="ri-thumb-up-fill"></i> VALGT

                                        </div>
                                    }

                                    <ThemeBtn

                                        BtnClass={` like-dislike dislike ' 
                                        ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''
                                            }`.trim()}
                                        BtnText={(
                                            <>
                                                <i class="ri-thumb-down-fill"></i>

                                            </>
                                        )
                                        }
                                        onClick={props.handleDeleteActivity}
                                    />


                                   


                                </div>
                            </div>
                        </div>

                        {props.isManualOrder && (
                            <div>
                                <Link
                                    to={`/aktivitet/${res}?id=${activity.id}&isManualOrder=1`}
                                    className="Theme_btn_primary load_more_btn text-center"
                                >
                                    Manuell bestilling
                                </Link>
                            </div>
                        )}
                    </div>
                </>
            )}


           {props.isType && props.isType === "recommend-1" && (
                <div
                    draggable
                    onDragStart={props.handleDrag}
                    className={`col-lg-3 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr2     ${(localStorage.getItem('aktivitet-side') === activity.id ||
                        localStorage.getItem('aktiviteter') === activity.id) &&
                        (window.location.pathname === '/aktivitet-side' ||
                            window.location.pathname === '/aktiviteter')
                        ? "scrollToActivity"
                        : ""
                        }`}
                >

                    <div className={`outer-elemt2 ${!props.isVelgDisable && !activity.isVelgClick  ? 'disabled-container' : ''} ${activity.isVelgClick ? 'liked-section' : ''}`}>

                    

                        {/*<h5 class="header-circle hoverid761-header top-datesec"><b>{dayjs(activity.addDate).locale('nb').format('MMMM')}</b></h5>*/}

                        <div>
                            <div className="position-relative img_otr">
                                <div className="card-menu">
                                    {activity.isVelgClick && (
                                        <>
                                            <div
                                                className="m9 edit_icon_otr icon_otr" onClick={props.handleActivityEditClick}>
                                                < i class="ri-pencil-line  edit_icon"></i>
                                            </div>
                                        </>)}
                                    <div
                                        className="m9 edit_icon_otr icon_otr"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (props.source === "customer" || props.source === "partner") {
                                                toActivityDetails();
                                                localStorage.setItem('aktiviteter', activity.id);
                                            }
                                        }}
                                    >
                                        < i class="ri-search-line edit_icon"></i>

                                    </div>
                                   
                                </div>
                                <Link
                                    className=""
                                    to={
                                        props.source === "customer" || props.source === "partner"
                                            ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                            : "#"
                                    }
                                >
                                    <img
                                        className="card_imgS"
                                        src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                        alt="img"
                                        loading="eager"
                                        style={{
                                            opacity: imageLoaded ? 1 : 0.3,  // Starts with low opacity
                                            transition: "opacity 0.5s ease-in-out", // Smooth fade-in effect
                                        }}
                                        onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                        onError={() => setImageError(true)} // If image fails, show fallback

                                    />
                                </Link>
                                {activity.discountPercent > 0 && activity.discountPercent < 100 && (
                                    <div>
                                        {/*    <p className="rabat_card_info shadow">-{activity.discountPercent}%</p>*/}
                                    </div>
                                )}
                            </div>
                            <div className="content">
                                <Link
                                    className="heading-lb card_heading"
                                    to={
                                        props.source === "customer" || props.source === "partner"
                                            ? `/aktivitet/${res}?id=${activity.id}&type=B2B`
                                            : "#"
                                    }
                                >
                                    {props.CardHeading}
                                </Link>
                                <div className="d-flex flex-row justify-content-between mid">
                                    <div className="d-flex flex-column align-left bd-r">
                                        <small className="text-muted "><b>PRIS:</b></small>
                                        <div className="d-flex flex-row">

                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj">{props.CardDesc}</small>
                                            </div>
                                        </div>

                                        <small className="text-muted"><b>TOTALSUM:</b></small>
                                        <div className="d-flex flex-row">

                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj h-43">{(activity?.price || 0) * (activity?.minPerson + activity.totPersons)} NOK</small>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="d-flex flex-column align-left">
                                        <small className="text-muted "><b>ANTALL:</b></small>
                                        <div className="d-flex flex-column">
                                            <div className="d-flex flex-column ml-1 mb-1">
                                                <small className="ghj">{(activity.minPerson + activity.totPersons)}</small>
                                            </div>
                                        </div>

                                        {activity.isVelgClick && (
                                            <>
                                                <small className="text-muted">
                                                    <b>DATO:</b>
                                                </small>
                                                <div className="d-flex flex-column">
                                                    <div className="d-flex flex-column ml-1 mb-1">
                                                        <small className="ghj fnt12">{DateFormat(activity.addDate)}</small>
                                                    </div>
                                                </div>
                                            </>
                                        )}


                                    </div>
                                </div>
                            </div>
                            <div className="dflex w-100" >

                                {!activity.isVelgClick &&
                                    <ThemeBtn
                                        BtnClass={` like-dislike like ${activity.isVelgClick ? 'disabled' : ''}   ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''}`}
                                        BtnText={
                                            <>
                                                <i className="ri-thumb-up-fill"></i>
                                            </>
                                        }
                                        onClick={props.clickFire}
                                    />
                                }

                                {activity.isVelgClick &&
                                    <div
                                        className={` like-dislike-selected `}
                                    
                                    >
                                        <i className="ri-thumb-up-fill"></i> VALGT

                                    </div>
                                }

                                <ThemeBtn

                                    BtnClass={` like-dislike dislike ' 
                                        ${!props.isVelgDisable && !activity?.isVelgClick ? 'disabled' : ''
                                        }`.trim()}
                                    BtnText={(
                                        <>
                                            <i class="ri-thumb-down-fill"></i>

                                        </>
                                    )
                                    }
                                    onClick={props.handleDeleteActivity}
                                />




                            </div>
                        </div>
                    </div>

                    {props.isManualOrder && (
                        <div>
                            <Link
                                to={`/aktivitet/${res}?id=${activity.id}&isManualOrder=1`}
                                className="Theme_btn_primary load_more_btn text-center"
                            >
                                Manuell bestilling
                            </Link>
                        </div>
                    )}
                </div>
            )}

        
            {!props.isType && <div draggable onDragStart={props.handleDrag} className={` col-lg-3 col-md-4 col-sm-6 col_searchCard_otr col_searchCard_inr ${(localStorage.getItem('aktivitet-side') === activity.id || localStorage.getItem('aktiviteter') === activity.id) &&
                (window.location.pathname === '/aktivitet-side' || window.location.pathname === '/aktiviteter')
                ? "scrollToActivity"
                : ""
                }`}>

                <div className={`outer-elemt outer-element-other-main ${!props.isVelgDisable && !props.isVelgDisable  ? 'disabled-container' : ''}`}>

                    <div>
                        <div className="position-relative img_otr">

                            <div class="card-menu " >

                                <div className={`m9 edit_icon_otr icon_otr`} onClick={(e) => {
                                    
                                    e.stopPropagation(); // Add this line to stop event propagation
                                    if (props.source === "customer" || props.source === "partner") {
                                        toActivityDetails();
                                        return localStorage.setItem('aktiviteter', activity.id);
                                    }

                                }}>
                                    <i className={`ri-search-line  edit_icon`}></i>
                                </div>

                            </div>
                            <img
                                className="card_imgS"
                                src={imageError ? fallbackImage : props.CardImg.replace("{baseApiURL}", "https://funtlers.com/")}
                                alt="img"
                                loading="eager"
                                style={{
                                    opacity: imageLoaded ? 1 : 0.3,  // Starts with low opacity
                                    transition: "opacity 0.5s ease-in-out", // Smooth fade-in effect
                                }}
                                onLoad={() => setImageLoaded(true)} // Triggers when image fully loads
                                onError={() => setImageError(true)} // If image fails, show fallback

                            />
                            {activity.discountPercent > 0 && activity.discountPercent < 100 ? <div><p className="rabat_card_info shadow">-{activity.discountPercent}%</p></div> : ""}
                        </div>
                        <div className="content">
                            <Link className="heading-lb card_heading" to={props.source === "customer" || props.source === "partner" ? "/aktivitet/" + res + "?id=" + activity.id + "&type=B2B" : ""}>{props.CardHeading}</Link>
                            <p className="heading-s card_desc_activity text-center">
                                {props.CardDesc}
                            </p>
                        </div>

                        <div>
                            <ThemeBtn
                                BtnClass={`Theme_btn_primary w-100 send_btn ${!activity.isVelgClick ? '' : 'Theme_btn_black'} ${!props.isVelgDisable ? 'disabled' : ''}`}
                                BtnText={!activity.isVelgClick ? "VELG" : "VALGT"}
                                onClick={!activity.isVelgClick ? props.clickFire : undefined}
                            />

                        </div>



                    </div>
                </div>
                {
                    props.isManualOrder === "true" && (
                        <div>
                            <Link to={"/aktivitet/" + res + "?id=" + activity.id + "&isManualOrder=1"} class="Theme_btn_primary load_more_btn text-center" >
                                Manuell bestilling
                            </Link>
                        </div>
                    )
                }
            </div>}

        </>
    )
    

}

export default OrderPlanSearchResultCard;
